import React from 'react'

function Footer() {
  return (
    <div className='footer'>
       <p className='footer-body'>copyright &copy;2022 EestiBikes</p>
       
    
      

     
      

     
        </div>
  )
}

export default Footer